export interface ICustomer {
  id: number;
  name: string;
  registryNumber: string;
  eic: string;
  address: string;
  electricityInvoiceRecipientEmail: string;
  agreementsCount: number;
  isPerson: boolean;
  isGroupInvoicingEnabled: boolean;
  isFactoringClient: boolean;
  bankAccountNumber?: string
  receiveInvoiceByEmail: boolean;
}

export interface ISimplifiedCustomer {
  id: number;
  noomId: number;
  name: string;
  registryNumber: string;
}

export enum ElectricityCustomerSortFields {
  ID = "ID",
  NAME = "NAME",
  REGISTRY_NUMBER = "REGISTRY_NUMBER",
  EIC = "EIC"
}